import { Button, Col, Form, Input, Row, Typography } from 'antd';
import React, { FC } from 'react';

import { messages, MessageTypes } from '../../../../pages/Auth/messages';
import { MaskedInput, StatesSelect } from '../../../common';
import { FormFooter, FormGroup, FormWrapper, StepContent } from '../styled';
import { BaseProps, ProfileType } from '../types';

const ProfileForm: FC<BaseProps<ProfileType>> = ({
  initialValues,
  onSubmit,
  type,
  onBack,
}) => {
  const [profileForm] = Form.useForm();

  return (
    <StepContent>
      <Typography.Title level={3}>
        2. Update your Personal Information
      </Typography.Title>
      <FormWrapper>
        <Form
          form={profileForm}
          initialValues={initialValues}
          layout="vertical"
          onFinish={onSubmit}
        >
          <FormGroup title="Personal info">
            <Row gutter={[24, 0]}>
              <Col span={12}>
                <Form.Item
                  name="firstName"
                  hasFeedback
                  label="First Name"
                  rules={[
                    {
                      required: true,
                      message: messages[MessageTypes.RequiredField],
                    },
                  ]}
                >
                  <Input
                    autoComplete="off"
                    autoCapitalize="off"
                    size="large"
                    placeholder="Enter your First Name"
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="lastName"
                  hasFeedback
                  label="Last Name"
                  rules={[
                    {
                      required: true,
                      message: messages[MessageTypes.RequiredField],
                    },
                  ]}
                >
                  <Input
                    autoComplete="off"
                    autoCapitalize="off"
                    size="large"
                    placeholder="Enter your Last Name"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[24, 0]}>
              <Col span={12}>
                <Form.Item name="middleName" hasFeedback label="Middle Name">
                  <Input
                    autoComplete="off"
                    autoCapitalize="off"
                    size="large"
                    placeholder="Enter your Middle Name"
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="phoneNumber"
                  label="Phone Number"
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: messages[MessageTypes.RequiredField],
                    },
                  ]}
                >
                  <MaskedInput
                    mask="+1(999) 999-9999"
                    size="large"
                    placeholder="Phone Number"
                  />
                </Form.Item>
              </Col>
            </Row>
          </FormGroup>
          <FormGroup title="Address Info">
            <Form.Item
              label="Address Line 1"
              preserve={false}
              name="addressLine1"
              hasFeedback
              rules={[
                {
                  required: true,
                  message: messages[MessageTypes.RequiredField],
                },
              ]}
            >
              <Input type="text" placeholder="Address Line 1" size="large" />
            </Form.Item>
            <Form.Item
              label="Address Line 2"
              preserve={false}
              name="addressLine2"
            >
              <Input type="text" placeholder="Address Line 2" size="large" />
            </Form.Item>
            <Row gutter={[8, 0]}>
              <Col span="18">
                <Form.Item
                  label="City"
                  preserve={false}
                  name="city"
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: messages[MessageTypes.RequiredField],
                    },
                  ]}
                >
                  <Input type="text" placeholder="City" size="large" />
                </Form.Item>
              </Col>
              <Col span="6">
                <Form.Item
                  label="State"
                  hasFeedback
                  preserve={false}
                  rules={[
                    {
                      required: true,
                      message: messages[MessageTypes.RequiredField],
                    },
                  ]}
                  name="state"
                >
                  <StatesSelect size="large" />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item
              label="Zipcode"
              wrapperCol={{ span: 8 }}
              preserve={false}
              hasFeedback
              name="zipCode"
              rules={[
                {
                  required: true,
                  message: messages[MessageTypes.RequiredField],
                },
              ]}
            >
              <MaskedInput mask="99999" />
            </Form.Item>
          </FormGroup>
          <FormFooter>
            <Button
              size="large"
              type="primary"
              onClick={onBack}
              style={{ marginRight: '10px' }}
            >
              Back
            </Button>
            <Button size="large" type="primary" htmlType="submit">
              {type === 'MANAGER' || type === 'CLINICAL_USER'
                ? 'Submit'
                : 'Next'}
            </Button>
          </FormFooter>
        </Form>
      </FormWrapper>
    </StepContent>
  );
};

export default ProfileForm;
